import {
  SET_ERROR,
  SET_LOADING,
  SET_ORDERS,
  SET_ORDER,
  SET_BANK_ACCOUNT_ORDERS,
  SET_BANK_ACCOUNT_ORDER
} from '../constants/support';

const initialState = {
  orders: null,
  order: null,
  bankAccountsOrders: null,
  bankAccountsOrder: null,
  loading: true,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDERS:
      return {
        ...state,
        loading: false,
        orders: action.payload,
      };

    case SET_ORDER:
      return {
        ...state,
        order: action.payload,
      };

    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SET_BANK_ACCOUNT_ORDERS:
      return {
        ...state,
        loading: false,
        bankAccountsOrders: action.payload,
      };

    case SET_BANK_ACCOUNT_ORDER:
      return {
        ...state,
        loading: false,
        bankAccountsOrder: action.payload,
      };

    default:
      return state;
  }
};
